module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0033.png.b6045a9a.jpg";